module.exports = __webpack_public_path__ + "img/ticket.3f3cdb9a.png";